import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LabService } from '../../../../services/lab.service';
import { ActivatedRoute } from '@angular/router';
import { CustomValidators} from '@utility';

@Component({
  selector: 'cloudlabs-dynamic-parameters',
  templateUrl: './dynamic-parameters.component.html',
  styleUrls: ['./dynamic-parameters.component.scss']
})
export class DynamicParametersComponent implements OnInit {
  @Input() dynamicParameters: any[] = [];
  @Input() selectedRegion: any;
  @Input() lab: any;
  @Output() startLab = new EventEmitter<any>();
  dynamicForm: FormGroup;
  private voucherCode: string;


  constructor(
    private fb: FormBuilder,
    private labSrv: LabService,
    private aroute: ActivatedRoute,
  ) { 
    this.aroute.params.subscribe((i) => {
      this.voucherCode = i.voucherCode
    })
  }

  ngOnInit(): void {
    const group = {};

    this.dynamicParameters.forEach(field => {
      if (field.inputType === 'checkbox') {
        field.value = field.value === true || String(field.value).toLowerCase() === 'true';
        group[field.name] = [field.value, Validators.requiredTrue];
      } else {
        group[field.name] = [
          field.value,
          field.inputType === 'password'
            ? [Validators.required, CustomValidators.noAtSymbolValidator()]
            : Validators.required
        ];
      }
    });

    this.dynamicForm = this.fb.group(group);
  }
  
  onSubmit(): void {
    if (this.dynamicForm.invalid) {
      this.dynamicForm.markAllAsTouched();
      return;
    }
  
    const responses = {};
  
    this.dynamicParameters.forEach(field => {
      responses[field.name] = {
        inputType: field.inputType,
        value: this.dynamicForm.get(field.name)?.value
      };
  
      if (field.inputType === 'list') {
        responses[field.name].inputValues = field.inputValues;
      }
    });
  
    const payload = { responses };
    this.labSrv.saveDynamicParameters(this.voucherCode, payload).subscribe((res: any) => {
      if(res.success === true) {
        this.startLab.emit(payload);
      }
      
    })
  }

}
